<ng-template #windowTitleBar let-win>
  <span class="k-window-title"><span class="k-icon k-font-icon k-icon-xl k-i-form-element">
    </span> {{showTitle}}</span>
  <button kendoWindowCloseAction [window]="win"></button>
</ng-template>
<div class="k-overlay" *ngIf="editWinOpen"></div>

<div class="container" my-5>
  <div class="card" #appendTo>
    <div class="card-body no-border">
      <div class="card-title">
        <h3 style="text-align: left;" class="page-header"><fa-icon class="fa-solid fa-duotone"
            [icon]="['fad', 'sliders']"></fa-icon> Manage Evaluations</h3>
      </div>

      <kendo-grid [kendoGridBinding]="gridData" [sort]="sort" [sortable]="true" [groupable]="true" [resizable]="true"
        [filter]="filter" filterable="menu" (filterChange)="filterChange($event)" (sortChange)="sortChange($event)"
        style="height: calc(100vh - 200px); min-height: 400px;" [pageSize]="pageSize" [pageable]="true">

        <ng-template kendoGridToolbarTemplate position="top">
          <button [hidden]="!canCreate" (click)="onAddClick( windowTitleBar)" kendoButton class="btn btn-primary">
            <fa-icon icon="circle-plus"></fa-icon> Add Evaluation </button>
        </ng-template>

        <kendo-grid-column title="Edit" [width]="70">
          <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
            <button [hidden]="!canUpdate" (click)="onEditClick(dataItem, windowTitleBar)" kendoButton
              class="btn btn-stn-grid">
              <fa-icon icon="edit"></fa-icon>
            </button>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column title="Copy" [width]="70">
          <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
            <button [hidden]="!canCreate" (click)="onCopyClick(dataItem, windowTitleBar)" kendoButton
              class="btn btn-stn-grid">
              <fa-icon icon="copy"></fa-icon>
            </button>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column title="Rating Scale" [width]="80">
          <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
            <button (click)="onRatingScaleClick(dataItem)" kendoButton class="btn btn-stn-grid" [hidden]="!canUpdate">
              {{dataItem.rating_scale_qty}}
            </button>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column title="Domains of Competencies" [width]="140">
          <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
            <button (click)="onDomainClick(dataItem)" kendoButton class="btn btn-stn-grid" [hidden]="!canUpdate">
              {{dataItem.domain_qty}}
            </button>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column title="Additional Questions" [width]="100">
          <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
            <button (click)="onQuestionClick(dataItem)" kendoButton class="btn btn-stn-grid" [hidden]="!canUpdate">
              {{dataItem.additional_question_qty}}
            </button>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column field="discipline_name" title="Discipline Description" [width]="200">
          <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter"
            let-filterService="filterService">
            <multicheck-filter [isPrimitive]="true" [field]="column.field" [filterService]="filterService"
              [currentFilter]="filter" [data]="distinctPrimitive(column.field)"></multicheck-filter>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column field="evaluation_name" title="Evaluation Name" [width]="200">
          <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter"
            let-filterService="filterService">
            <multicheck-filter [isPrimitive]="true" [field]="column.field" [filterService]="filterService"
              [currentFilter]="filter" [data]="distinctPrimitive(column.field)"></multicheck-filter>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column field="updated_by" title="Updated By" [width]="250">
          <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter"
            let-filterService="filterService">
            <multicheck-filter [isPrimitive]="true" [field]="column.field" [filterService]="filterService"
              [currentFilter]="filter" [data]="distinctPrimitive(column.field)"></multicheck-filter>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column field="updatedAt" title="Updated On" [width]="120" [filterable]="false">
          <ng-template kendoGridCellTemplate let-dataItem>
            {{ dataItem.updatedAt | date:'dd/MM/yyyy HH:mm' }}
          </ng-template>
        </kendo-grid-column>


        <kendo-grid-column title="Activate / Deactivate" field="active" [width]="130">
          <ng-template kendoGridCellTemplate let-dataItem>
            <input type="checkbox" kendoCheckBox size="large" [checked]="dataItem.active" (click)="setActive(dataItem)"
              [disabled]="!canDestroy" />
          </ng-template>
          <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter"
            let-filterService="filterService">
            <multicheck-filter [isPrimitive]="true" [field]="column.field" [filterService]="filterService"
              [currentFilter]="filter" [data]="distinctPrimitive(column.field)"></multicheck-filter>
          </ng-template>
        </kendo-grid-column>


        <ng-template kendoPagerTemplate>
          <kendo-pager-info *ngIf="pageSize > 0"></kendo-pager-info>
        </ng-template>

      </kendo-grid>

    </div>
  </div>

</div>

<div kendoDialogContainer></div>

<div kendoWindowContainer></div>
